export const ToggleCard = (target: HTMLLabelElement) => {

  const el = {
    root: target,
    input: target.querySelector<HTMLInputElement>('.toggle__input')
  }

  const method = {

    init: () => {
      if (!el.input) return
      el.input.addEventListener('change', method.onChange)
    },

    onChange: (e: Event & { target: HTMLInputElement }) => {
      if (!e.target.checked) {
        el.root.classList.remove('toggle-card--selected')
        return
      }
      el.root.classList.add('toggle-card--selected')
    },
  }

  method.init()
}